document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header-wrapper');
  if (!header) return;

  const headerHeight = () => header.offsetHeight;

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href');
      if (targetId === '#' || targetId === '') return;

      const target = document.querySelector(targetId);
      if (!target) return;

      e.preventDefault();

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerHeight();

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });
});